/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pricing_ContactInputs */

const en_directory_pricing_contact = /** @type {(inputs: Directory_Pricing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const zh_directory_pricing_contact = /** @type {(inputs: Directory_Pricing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系定价`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Directory_Pricing_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pricing_contact = /** @type {((inputs?: Directory_Pricing_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pricing_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pricing_contact(inputs)
	return zh_directory_pricing_contact(inputs)
});
export { directory_pricing_contact as "directory.pricing.contact" }